import React from 'react';
import { motion } from 'framer-motion';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: 'Implementation of Federated Learning Workflow',
      description: 'Performed a detailed literature review of the vanilla federated learning paper "Communication-Efficient Learning of Deep Networks from Decentralized Data". Developed a simulation of the federated averaging workflow to model and analyze its performance in a distributed edge computing environment. The state-of-the-art literature survey included encryption and privacy-preserving methods for secure Federated Learning.',
      tech: ['Python', 'Flower', 'PyTorch'],
      image: '🤖',
      link: '#',
      github: 'https://github.com/23CSE362-edge-computing-2025-26-odd/edge-cloud-architecture-07_cyberdynesystems.git',
      date: 'August 2025 - September 2025',
    },
    {
      id: 2,
      title: 'Kubernetes Voting App - Deployment',
      description: 'Deployed a microservices-based voting app using Kubernetes on Docker Desktop. Integrated Python Flask, .NET Core, Redis, and PostgreSQL. Authored pods and services YAML files for deployment using Kubernetes Deployments.',
      tech: ['Kubernetes', 'Docker', 'Flask', '.NET', 'Redis', 'PostgreSQL'],
      image: '🗳️',
      link: '#',
      github: 'https://github.com/YuvanDhurkesh/kubernetes-voting-app-using-deployments.git',
      date: 'August 2025',
    },
    {
      id: 3,
      title: 'Kubernetes Voting App - Pods',
      description: 'Deployed a microservices-based voting app using Kubernetes on Docker Desktop with Pod-based architecture. Integrated Python Flask, .NET Core, Redis, and PostgreSQL. Authored pods and services YAML files for deployment using Kubernetes Pods.',
      tech: ['Kubernetes', 'Docker', 'Flask', '.NET', 'Redis', 'PostgreSQL'],
      image: '📦',
      link: '#',
      github: 'https://github.com/YuvanDhurkesh/kubernetes-voting-app.git',
      date: 'August 2025',
    },
    {
      id: 4,
      title: 'Cloud-based Native Monitoring Application on Kubernetes',
      description: 'Developed a real-time server monitoring application from scratch using Python and Flask. The application was containerized with Docker for portability and consistent deployment. Cloud infrastructure, specifically the AWS ECR repository, was automated using Python\'s boto3 library. Deployment to a managed Kubernetes cluster (AWS EKS) was orchestrated programmatically. This project demonstrated an end-to-end, scalable, cloud-native deployment workflow.',
      tech: ['Python', 'Flask', 'Kubernetes', 'Docker', 'AWS EKS', 'AWS ECR'],
      image: '☁️',
      link: '#',
      github: '#',
      date: 'September 2025',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  return (
    <div className="projects">
      <div className="projects-container">
        <motion.div
          className="projects-header"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">
            My <span className="gradient-text">Projects</span>
          </h1>
          <div className="title-underline"></div>
          <p className="page-description">
            Here are some of my recent projects that showcase my skills and experience
          </p>
        </motion.div>

        <motion.div
          className="projects-grid"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {projects.map((project) => (
            <motion.a
              key={project.id}
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className="project-card"
              variants={cardVariants}
              whileHover={{ y: -10, scale: 1.02 }}
              transition={{ duration: 0.3 }}
              title={project.github}
            >
              <div className="project-image">
                <div className="project-icon">{project.image}</div>
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                {project.date && <p className="project-date">{project.date}</p>}
                <p className="project-description">{project.description}</p>
                <div className="project-tech">
                  {project.tech.map((tech, index) => (
                    <span key={index} className="tech-tag">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </motion.a>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Projects;
